import { useMemo } from "react"
import { useLocation } from "react-router-dom"

export default function useSearchParams() {
  const location = useLocation() || window.location
  const { search } = location
  return useMemo(() => new URLSearchParams(search), [search])
}
